import React, { useState } from 'react';
import { db } from '../services/db';
import { registerUser } from '../services/api';
import '../styles/Modal.css';

interface UserSetupModalProps {
  onComplete: () => void;
  initialName?: string;
  initialEmail?: string | null;
}

const UserSetupModal: React.FC<UserSetupModalProps> = ({ onComplete, initialName, initialEmail }) => {
  const [name, setName] = useState(initialName ?? '');
  const [email, setEmail] = useState(initialEmail ?? '');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert('Please enter your name');
      return;
    }

    if (!email.trim()) {
      alert('Please enter your email address');
      return;
    }
    
    try {
      await db.setUserInfo(name.trim(), email.trim());
      // Also save to localStorage for easy access in other components
      localStorage.setItem('userEmail', email.trim());
      
      // Try to register with backend (fire and forget)
      registerUser(name.trim(), email.trim());
      
      onComplete();
    } catch (error) {
      console.error('Error saving user info:', error);
      alert('Failed to save your information. Please try again.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Welcome to Time Trakr Lite</h2>
        <p>Please enter your details to get started:</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Your Name:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>
          
          <div className="modal-buttons">
            <button type="submit" className="save-btn">
              Get Started
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserSetupModal;
